import { PhotoSalesFactory } from './photoSalesFactory';

import type {
  PhotoSalesPropsPub,
  PhotoSalesPropsPvt,
  PhotoSalesEntity,
} from './photoSalesEntity';
import type { PhotoSalesIRepository } from './photoSalesIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { PhotoSalesJsonPub, PhotoSalesJsonPvt } from '@/types/domain/photo/entities/photoSalesEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * 写真販売レポジトリ
 */
export class PhotoSalesRepository extends AppsyncRepository<
  PhotoSalesEntity,
  PhotoSalesPropsPvt,
  PhotoSalesJsonPvt,
  PhotoSalesPropsPub,
  PhotoSalesJsonPub
> implements PhotoSalesIRepository {
  private factory = new PhotoSalesFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryPhotoPhotoSalesEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
